// Canonical service taxonomy emitted by the CSV ingest lambda's
// `deriveFacets` (`packages/lambdas/src/sqs/advisors-csv-ingest/facets.ts`).
// These strings match what is stored in `RiaFirm.services` in Postgres.
export const ALL_SERVICES = [
  'Financial Planning',
  'Portfolio Management',
  'Pension Consulting',
  'Selection of Other Advisers',
  'Publication of Periodicals',
  'Security Ratings / Pricing Services',
  'Educational Seminars/Workshops',
] as const;

export type Service = (typeof ALL_SERVICES)[number];
